/**
 * فقط گونه‌های ی و ک را مطابق PersianText در لایه دامنه یکسان می‌کند.
 * فاصله، نیم‌فاصله، ارقام و بزرگی حروف حفظ می‌شوند؛ برای توکن یا آدرس فایل استفاده نشود.
 */
export function normalizePersianText(value = '') {
  return String(value ?? '')
    .replace(/[يى]/g, 'ی')
    .replace(/ك/g, 'ک');
}

/** مخصوص جستجوی متن نمایشی است؛ حذف فاصله و تغییر بزرگی حروف برای رمز عبور مجاز نیست. */
export function normalizeSearchText(value = '') {
  return normalizePersianText(value).trim().toLocaleLowerCase('fa-IR');
}

/** تکرار رمز را با قاعده حروف سرور مقایسه می‌کند؛ متن اصلی رمز را تغییر نمی‌دهد. */
export function passwordsMatch(first, second) {
  return normalizePersianText(first) === normalizePersianText(second);
}
